import { render, staticRenderFns } from "./RecognizingAnOrderFromOutsideBc.vue?vue&type=template&id=273861ee"
import script from "./RecognizingAnOrderFromOutsideBc.vue?vue&type=script&lang=ts"
export * from "./RecognizingAnOrderFromOutsideBc.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports